import { useState, useEffect } from 'react';
import I18n from 'I18n';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { useServiceComponent } from '../../hooks/useServiceComponent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReconnectButtonNewConcept = ({
  buttonComponent: ButtonComponent,
  buttonProps,
  'data-test-id': dataTestId,
  label,
  loading,
  failed,
  fallback,
  metadata,
  onAuthStarted,
  onAuthCancelled,
  onAuthFailed,
  onAuthSucceeded,
  timeout,
  url
}) => {
  const [reconnectStarted, setReconnectStarted] = useState(false);
  const {
    serviceComponent: ServiceComponent,
    loading: serviceComponentLoading,
    error: serviceComponentError,
    isLoaded: serviceComponentIsLoaded
  } = useServiceComponent({
    metadata,
    url
  });
  useEffect(() => {
    if (serviceComponentError) {
      onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
        error: serviceComponentError,
        errorMessage: I18n.text('reconnectionError.commonMessage')
      });
    }
  }, [serviceComponentError, onAuthFailed]);
  if (!ServiceComponent && serviceComponentIsLoaded) {
    return fallback || null;
  }
  const handleOnClick = evt => {
    var _buttonProps$onClick;
    setReconnectStarted(true);
    buttonProps === null || buttonProps === void 0 || (_buttonProps$onClick = buttonProps.onClick) === null || _buttonProps$onClick === void 0 || _buttonProps$onClick.call(buttonProps, evt);
    onAuthStarted === null || onAuthStarted === void 0 || onAuthStarted();
  };
  const handleAuthCancelled = args => {
    onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled(args);
    setReconnectStarted(false);
  };
  const handleAuthFailed = args => {
    onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed(args);
    setReconnectStarted(false);
  };
  const handleAuthSucceeded = token => {
    onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(token);
    setReconnectStarted(false);
  };
  const updatedButtonProps = Object.assign({}, buttonProps, {
    disabled: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.disabled) || reconnectStarted,
    onClick: handleOnClick
  });
  return ServiceComponent ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [ButtonComponent ? /*#__PURE__*/_jsx(ButtonComponent, Object.assign({}, updatedButtonProps, {
      "data-test-id": dataTestId,
      children: label
    })) : /*#__PURE__*/_jsx(LoadingButton, Object.assign({}, updatedButtonProps, {
      "data-test-id": dataTestId,
      loading: loading || serviceComponentLoading || reconnectStarted,
      failed: failed === undefined || failed,
      children: label
    })), /*#__PURE__*/_jsx(ServiceComponent, {
      url: url,
      metadata: metadata,
      onAuthCancelled: handleAuthCancelled,
      onAuthFailed: handleAuthFailed,
      onAuthSucceeded: handleAuthSucceeded,
      reconnectStarted: reconnectStarted,
      timeout: timeout
    })]
  }) : null;
};